export const filterOption = (input: string, option: any) => {
  const label = String(option?.label || "");
  if (input) {
    return label.toLowerCase().includes(input.toLowerCase());
  }
  return false;
};
